import { useEffect, useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Tabs, Select, Input, InputNumber, Form, Button, Checkbox, Modal, message, Tooltip, Radio } from "antd";
import UserInfo from "../../components/UserInfo";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import LeadLogo from "../../assets/lead_logo.svg";
import "../../Opp.css";
import "../../MediaPreview.css";
import { createOrderDetails, getSchoolDetails } from "../../services/fetchApis";
import { DEVICE_TYPE_INFO, ORDER_TYPES, PRODUCT_VARIANTS, NEW_PRODUCT_VARIANTS } from "../../constants/OppContants";
const deviceOptions = Object.keys(DEVICE_TYPE_INFO)
const orderTypeOptions = Object.values(ORDER_TYPES)
const AGREEMENT_TYPES = ["PB", "PC", "PD", "PE", "PX", "PY", "PZ", "PAA", "PF"];
const SD_CARD_SIZES = ["64GB", "128GB", "256GB"];
const STATIC_ORBITER_PROFILES = [
    { id: 597, name: "AY9_Pinnacle_PPtoG8_CBSE_Winter" },
    { id: 700, name: "AY9_Pinnacle_PPtoG8_CBSE_Pbase" },
    { id: 701, name: "AY9_Pinnacle_PPtoG8_CBSE_Oldschools" },
    { id: 702, name: "AY9_Pinnacle_PPtoG8_CBSE_NEWschools" },
    { id: 598, name: "AY9_Propel_PPtoG5_CBSE_Winter" },
    { id: 703, name: "AY9_Propel_PPtoG5_CBSE_Pbase" },
    { id: 704, name: "AY9_Propel_PPtoG5_CBSE_Oldschools" },
    { id: 705, name: "AY9_Propel_PPtoG5_CBSE_NEWschools" },
    { id: 715, name: "AY9_LEAD_PPtoG10_RJSCERT_OLD" },
    { id: 714, name: "AY9_LEAD_PPtoG10_RJSCERT_NCFAligned" },
    { id: 716, name: "AY9_LEAD_PPtoG10_RJSCERT_NCFNonAligned" },
    { id: 750, name: "AY9_LEAD_PPtoG10_RJSCERT_Newschools" },
    { id: 776, name: "AY9_LEAD_PPtoG10_APSCERT_OLD" },
    { id: 777, name: "AY9_LEAD_PPtoG10_APSCERT_NCFAligned" },
    { id: 778, name: "AY9_LEAD_PPtoG10_APSCERT_NCFNonAligned" },
    { id: 779, name: "AY9_LEAD_PPtoG10_APSCERT_Newschools" },
    { id: 774, name: "AY9_LEAD_PPtoG10_TLSCERT_OLD" },
    { id: 775, name: "AY9_LEAD_PPtoG10_TLSCERT_NCFAligned" },
    { id: 780, name: "AY9_LEAD_PPtoG10_TLSCERT_NCFNonAligned" },
    { id: 781, name: "AY9_LEAD_PPtoG10_TLSCERT_Newschools" },
    { id: 795, name: "AY9_LEAD_PPtoG10_TNSCERT_OLD" },
    { id: 796, name: "AY9_LEAD_PPtoG10_TNSCERT_NCFAligned" },
    { id: 797, name: "AY9_LEAD_PPtoG10_TNSCERT_NCFNonAligned" },
    { id: 798, name: "AY9_LEAD_PPtoG10_TNSCERT_Newschools" },
    { id: 804, name: "AY9_LEAD_PPtoG10_KASCERT_OLD" },
    { id: 805, name: "AY9_LEAD_PPtoG10_KASCERT_NCFAligned" },
    { id: 806, name: "AY9_LEAD_PPtoG10_KASCERT_NCFNonAligned" },
    { id: 807, name: "AY9_LEAD_PPtoG10_KASCERT_Newschools" },
    { id: 601, name: "AY9_LEADAltus_PPtoG10_CBSE_Winter" },
    { id: 706, name: "AY9_LEADAltus_PPtoG10_CBSE_Pbase" },
    { id: 707, name: "AY9_LEADAltus_PPtoG10_CBSE_Newschools" },
    { id: 731, name: "AY9_LEADAltus_PPtoG10_CBSE_Oldschools" },
    { id: 602, name: "AY9_LEADAltus_PPtoG5_CBSE_Winter" },
    { id: 708, name: "AY9_LEADAltus_PPtoG5_CBSE_Pbase" },
    { id: 709, name: "AY9_LEADAltus_PPtoG5_CBSE_Newschools" },
    { id: 754, name: "AY9_LEADAltus_PPtoG5_CBSE_Oldschools" },
    { id: 607, name: "AY9_LEAD_G6toG10_CBSE_Winter" },
    { id: 710, name: "AY9_LEAD_G6toG10_CBSE_Pbase" },
    { id: 711, name: "AY9_LEAD_G6toG10_CBSE_Newschools" },
    { id: 755, name: "AY9_LEAD_G6toG10_CBSE_Oldschools" },
    { id: 699, name: "AY9_LEADTechbook_PPtoG5_CBSE_Winter" },
    { id: 717, name: "AY9_LEADTechbook_PPtoG5_CBSE_Pbase" },
    { id: 718, name: "AY9_LEADTechbook_PPtoG5_CBSE_Newschools" },
    { id: 741, name: "AY9_LEADTechbook_PPtoG5_CBSE_Oldschools" },
    { id: 719, name: "AY9_LEADTechbook_PPtoG5_RJSCERT_OLD" },
    { id: 720, name: "AY9_LEADTechbook_PPtoG5_RJSCERT_NCFAligned" },
    { id: 721, name: "AY9_LEADTechbook_PPtoG5_RJSCERT_NCFNonAligned" },
    { id: 751, name: "AY9_LEADTechbook_PPtoG5_RJSCERT_NewSchools" },
    { id: 782, name: "AY9_LEADTechbook_PPtoG5_APSCERT_OLD" },
    { id: 783, name: "AY9_LEADTechbook_PPtoG5_APSCERT_NCFAligned" },
    { id: 784, name: "AY9_LEADTechbook_PPtoG5_APSCERT_NCFNonAligned" },
    { id: 785, name: "AY9_LEADTechbook_PPtoG5_APSCERT_Newschools" },
    { id: 786, name: "AY9_LEADTechbook_PPtoG5_TLSCERT_OLD" },
    { id: 787, name: "AY9_LEADTechbook_PPtoG5_TLSCERT_NCFAligned" },
    { id: 788, name: "AY9_LEADTechbook_PPtoG5_TLSCERT_NCFNonAligned" },
    { id: 789, name: "AY9_LEADTechbook_PPtoG5_TLSCERT_Newschools" },
    { id: 799, name: "AY9_LEADTechbook_PPtoG5_TNSCERT_OLD" },
    { id: 800, name: "AY9_LEADTechbook_PPtoG5_TNSCERT_NCFAligned" },
    { id: 801, name: "AY9_LEADTechbook_PPtoG5_TNSCERT_NCFNonAligned" },
    { id: 802, name: "AY9_LEADTechbook_PPtoG5_TNSCERT_Newschools" },
    { id: 808, name: "AY9_LEADTechbook_PPtoG5_KASCERT_OLD" },
    { id: 809, name: "AY9_LEADTechbook_PPtoG5_KASCERT_NCFAligned" },
    { id: 810, name: "AY9_LEADTechbook_PPtoG5_KASCERT_NCFNonAligned" },
    { id: 811, name: "AY9_LEADTechbook_PPtoG5_KASCERT_Newschools" },
    { id: 891, name: "EH_PF_LEAD_CBSE_FBS_T1" },
    { id: 892, name: "EH_PF_Propel_T1" },
    { id: 893, name: "EH_PF_Pinnacle_T1" },
    { id: 928, name: "AY10_Propel_PP_P_E0" },
    { id: 929, name: "AY10_Lead_PP_P_E0" },
    { id: 930, name: "AY10_Lead_PP_P_MS_E0" },
    { id: 931, name: "AY10_Pinnacle_PP_P_E0" },
    { id: 932, name: "AY10_LeadTB_PP_P_E0" },
    { id: 933, name: "AY10_LeadTB_PP_P_MS_E0" },
    { id: 944, name: "AY10_Lead_Board_Ace" },
    { id: 3438, name: "AY10_Propel_APSB_PP_P_MS" },
    { id: 3439, name: "AY10_Propel_TLSB_PP_P_MS" },
    { id: 3432, name: "AY10_LeadTB_TNSB_PP_P_MS" },
    { id: 3431, name: "AY10_LeadTB_TLSB_PP_P_MS" },
    { id: 3426, name: "AY10_Lead_APSB_PP_P_MS" },
    { id: 3429, name: "AY10_Lead_KASB_PP_P_MS" },
    { id: 3427, name: "AY10_Lead_TLSB_PP_P_MS" },
    { id: 3504, name: "AndroidTestingProfile" },
    { id: 3435, name: "AY10_Pinnacle_TLSB_PP_P_MS" },
    { id: 3437, name: "AY10_Pinnacle_KASB_PP_P_MS" },
    { id: 3430, name: "AY10_LeadTB_APSB_PP_P_MS" },
    { id: 3441, name: "AY10_Propel_KASB_PP_P_MS" },
    { id: 3440, name: "AY10_Propel_TNSB_PP_P_MS" },
    { id: 3436, name: "AY10_Pinnacle_TNSB_PP_P_MS" },
    { id: 3434, name: "AY10_Pinnacle_APSB_PP_P_MS" },
    { id: 3433, name: "AY10_LeadTB_KASB_PP_P_MS" },
    { id: 3428, name: "AY10_Lead_TNSB_PP_P_MS" },
    { id: 3365, name: "AY10_Propel_PP_P_MS_E0" },
    { id: 893, name: "EH_PF_Pinnacle_T1" },
    { id: 932, name: "AY10_LeadTB_PP_P_E0_EA" }
];

const OrderCreationComponent = () => {
    const navigate = useNavigate();
    const [orderType, setOrderType] = useState("");
    const [agreementType, setAgreementType] = useState("");
    const [dealId, setDealId] = useState("");
    const [orpOrderId, setOrpOrderId] = useState("");
    const [referenceId, setReferenceId] = useState(null);
    const [hasCCS, setHasCCS] = useState(false);
    const [devices, setDevices] = useState(
        deviceOptions.reduce((acc, device) => ({ ...acc, [device]: [] }), {})
    );
    const [deviceErrors, setDeviceErrors] = useState({});
    const [nucleusErrors, setNucleusErrors] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [deviceLoading, setDeviceLoading] = useState({});
    // const [nucleusOptions, setNucleusOptions] = useState([]);
    // const [orbiterOptions, setOrbiterOptions] = useState([]);

    useEffect(() => {
    }, []);

    // useEffect(() => {
    //     const fetchNucleusOptions = async () => {
    //         // const data = await UserService.getNucleusIds();
    //         const data = [{}]
    //         setNucleusOptions(data);
    //     };
    //     const fetchOrbiterOptions = async () => {
    //         const data = [{}]
    //         // const data = await UserService.getOrbiterProfiles();
    //         setOrbiterOptions(data);
    //     };
    //     fetchNucleusOptions();
    //     fetchOrbiterOptions();
    // }, []);

    const validateFields = () => {
        let errors = {};

        // Validate main order fields
        if (!orderType) errors.orderType = "Order Type is required";
        if (!agreementType) errors.agreementType = "Agreement Type is required";
        if (!dealId) errors.dealId = "Deal ID is required";
        if (!orpOrderId) errors.orpOrderId = "Sales Order Number is required";

        // Validate devices
        Object.entries(devices).forEach(([deviceType, deviceList]) => {
            deviceList.forEach((device, index) => {
                let deviceKey = `${deviceType}-${index}`;
                let deviceError = {};

                if (!device.productVariant) deviceError.productVariant = "Product Variant is required";
                if (!device.deviceName) deviceError.deviceName = "Device Model is required";
                if (!device.quantity || device.quantity <= 0) deviceError.quantity = "Quantity must be greater than 0";

                if (deviceType === "TAB") {
                    if (!device.orbiterProfileId) deviceError.orbiterProfileId = "Orbiter Profile ID is required";
                    if (!device.sdCardSize) deviceError.sdCardSize = "SD Card Size is required";
                }

                if (deviceType === "PENDRIVE") {
                    if (device.productVariant === NEW_PRODUCT_VARIANTS.ACTIVE_TEACH && !device.activeTeachVersion) {
                        deviceError.activeTeachVersion = "Active Teach Version is required";
                    }
                    if (!device.installationMode) deviceError.installationMode = "Installation Mode is required";
                    if (!device.operatingSystem) deviceError.operatingSystem = "Operating System is required";
                }

                if (device.nucleusId && !device.schoolName) {
                    deviceError.nucleusId = "Please click the search button to validate the Nucleus ID.";
                }

                if (Object.keys(deviceError).length > 0) errors[deviceKey] = deviceError;
            });
        });

        setDeviceErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const addDevice = (deviceType) => {
        // TODO decide device type
        if (devices[deviceType].length < 3) {
            setDevices(prev => ({
                ...prev,
                [deviceType]: [...prev[deviceType], { productVariant: "", deviceName: "", quantity: 1, nucleusId: "", schoolName: "", orbiterProfileId: "", orbiterProfileName: "", sdCardSize: "", nucleusIdExists: true, isTechbook: false }]
            }));
        }
    };

    const updateDevice = (deviceType, index, key, value) => {
        setDevices(prev => {
            const updatedDevices = [...prev[deviceType]];
            updatedDevices[index][key] = value;

            // If toggling nucleusIdExists, reset fields
            if (key === "nucleusIdExists") {
                if (value === true) {
                    updatedDevices[index]["schoolName"] = "";
                } else {
                    updatedDevices[index]["nucleusId"] = "";
                    updatedDevices[index]["schoolName"] = "";
                }
            }

            // 🔹 If Nucleus ID is changed, clear School Name and add validation error
            if (key === "nucleusId") {
                updatedDevices[index]["schoolName"] = ""; // Clear school name

                setDeviceErrors(prevErrors => {
                    const updatedErrors = { ...prevErrors };
                    const deviceKey = `${deviceType}-${index}`;

                    if (!updatedErrors[deviceKey]) {
                        updatedErrors[deviceKey] = {};
                    }
                    updatedErrors[deviceKey]["nucleusId"] = "Please click the search button to validate the Nucleus ID.";

                    return updatedErrors;
                });
            }

            return { ...prev, [deviceType]: updatedDevices };
        });
    };

    const removeDevice = (deviceType, index) => {
        setDevices(prev => {
            const updatedDevices = prev[deviceType].filter((_, i) => i !== index);
            return { ...prev, [deviceType]: updatedDevices };
        });
    };

    const isSubmitDisabled = useMemo(() => {
        return !validateFields();
    }, [orderType, agreementType, dealId, orpOrderId, devices]);

    const handleSearch = async (deviceType, index, nucleusId) => {
        if (!nucleusId.trim()) {
            message.error("Please enter a Nucleus ID before searching.");
            return;
        }

        setDeviceLoading(prev => ({ ...prev, [`${deviceType}-${index}`]: true }));

        try {
            const data = await getSchoolDetails(nucleusId);
            if (data?.name) {
                updateDevice(deviceType, index, "schoolName", data.name);
                setNucleusErrors(prev => ({
                    ...prev,
                    [`${deviceType}-${index}`]: null, // Clear any previous errors
                }));
            } else {
                throw new Error("School name not found.");
            }
        } catch (error) {
            setNucleusErrors(prev => ({
                ...prev,
                [`${deviceType}-${index}`]: error.message || "Error fetching school name.",
            }));
            updateDevice(deviceType, index, "schoolName", null);
            updateDevice(deviceType, index, "nucleusId", null);
        } finally {
            // Remove loading state
            setDeviceLoading(prev => ({ ...prev, [`${deviceType}-${index}`]: false }));
        }
    };

    const handleSubmit = async (e) => {
        if (!validateFields()) {
            message.error("Please fix validation errors before submitting.");
            return;
        }
        const formattedDevices = Object.entries(devices).flatMap(([deviceType, deviceList]) =>
            deviceList.map(device => {
                device.deviceType = deviceType.toUpperCase().split().join('')
                deviceType = device.deviceType
                const deviceMapping = DEVICE_TYPE_INFO[deviceType]
                const deviceExists = deviceMapping ? deviceMapping.find(o => o.name == device.deviceName) : null
                const deviceMaterialCode = deviceMapping && deviceExists ? deviceExists.materialCode : null

                return {
                    nucleusId: device.nucleusId ? parseInt(device.nucleusId) : 0,
                    productVariant: device.productVariant,
                    sdCardSize: device.sdCardSize ? parseInt(device.sdCardSize) * 1024 : "",
                    orbiterProfileId: device.orbiterProfileId ? parseInt(device.orbiterProfileId) : "",
                    sdCardProfileName: device.orbiterProfileName || "",
                    deviceType,
                    deviceName: device.deviceName,
                    materialCode: deviceMaterialCode,
                    schoolName: device.schoolName,
                    schoolIdExists: device.nucleusIdExists,
                    activeTeachVersion: device.activeTeachVersion,
                    installationMode: device.installationMode,
                    operatingSystem: device.operatingSystem,
                    brand: device.brand || null,
                    series: deviceType === 'TAB' && device.isTechbook ? "Techbook" : null,
                    qty: device.quantity,
                }
            })
        );

        const requestData = {
            orderType,
            agreementType,
            referenceId,
            dealId,
            hasCCS,
            orpOrderId,
            devices: formattedDevices,
        };

        console.log(`request data: ${JSON.stringify(requestData)}`)

        try {
            const response = await createOrderDetails(requestData);
            if (response.status === 'OK') {
                Modal.success({
                    title: "Order Created Successfully",
                    content: `Your order has been placed successfully. Order ID: ${orpOrderId}`,
                });

                // Clear form data
                setOrderType("");
                setAgreementType("");
                setDealId("");
                setOrpOrderId("");
                setReferenceId(null);
                setHasCCS(false);
                setDevices(deviceOptions.reduce((acc, device) => ({ ...acc, [device]: [] }), {}));
            } else {
                throw new Error(response.message || "Order submission failed.");
            }
        } catch (error) {
            Modal.error({
                title: "Order Submission Failed",
                content: error.message || "An error occurred while submitting the order.",
            });
        }
    };

    const getProductVariants = (deviceType) => {
        let productVariants = Object.values(PRODUCT_VARIANTS);
        if (deviceType === 'PENDRIVE') {
            productVariants = Object.values(NEW_PRODUCT_VARIANTS);
        } else if (deviceType === 'PANEL') {
            productVariants = productVariants.concat(Object.values(NEW_PRODUCT_VARIANTS));
        }
        return productVariants;
    };

    return (
        <div className="order-page">
            <div className="top-header-inner-container">
                <FontAwesomeIcon icon="home" size="2x" className="home-icon" onClick={() => navigate(`/`, { replace: true })} />
                <img className="lead-logo" src={LeadLogo} alt="lead-logo" />
                <UserInfo />
            </div>
            <div className="order-creation-container">
                {/* font-size: 24px; */}
                <Card title="Create New Order" className="order-card" style={{}}>
                    <Form onFinish={handleSubmit} layout="vertical">
                        <Row gutter={16}>
                            <Col span={12}><Form.Item label="Order Type" validateStatus={deviceErrors.orderType ? "error" : ""} help={deviceErrors.orderType || ""}><Select value={orderType || undefined} onChange={setOrderType} placeholder="Select Order Type">{orderTypeOptions.map(type => <Select.Option key={type} value={type}>{type}</Select.Option>)}</Select></Form.Item></Col>
                            <Col span={12}><Form.Item label="Agreement Type" validateStatus={deviceErrors.agreementType ? "error" : ""} help={deviceErrors.agreementType || ""}><Select value={agreementType || undefined} onChange={setAgreementType} placeholder="Select Agreement Type">{AGREEMENT_TYPES.map(type => <Select.Option key={type} value={type}>{type}</Select.Option>)}</Select></Form.Item></Col>
                        </Row>
                        {[ORDER_TYPES.RETURN, ORDER_TYPES.REPLACEMENT_HARDWARE].includes(orderType) && (
                            <Row gutter={16}>
                                <Col span={12}><Form.Item label="Reference ID"><Input value={referenceId} placeholder="Enter Reference ID" onChange={(e) => setReferenceId(e.target.value)} /></Form.Item></Col>
                            </Row>
                        )}
                        <Row align="middle" gutter={16}>
                            <Col span={12}><Form.Item label="Deal ID" validateStatus={deviceErrors.dealId ? "error" : ""} help={deviceErrors.dealId}><Input value={dealId} placeholder="Enter Deal ID" onChange={(e) => setDealId(e.target.value)} required /></Form.Item></Col>
                            <Col span={12}><Form.Item label="Sales Order Number" validateStatus={deviceErrors.orpOrderId ? "error" : ""} help={deviceErrors.orpOrderId}><Input value={orpOrderId} placeholder="Enter Sales Order Number" onChange={(e) => setOrpOrderId(e.target.value)} required /></Form.Item></Col>
                            <Col span={12}><Checkbox className="ccs-checkbox" checked={hasCCS} onChange={(e) => setHasCCS(e.target.checked)}>Has CCS</Checkbox></Col>
                        </Row>
                        <Tabs>
                            {deviceOptions.map(deviceType => (
                                <Tabs.TabPane tab={deviceType} key={deviceType}>
                                    {devices[deviceType].map((device, index) => (
                                        <Card key={index} title={`${deviceType} TYPE #${index + 1}`} className="device-card" extra={<CloseOutlined onClick={() => removeDevice(deviceType, index)} className="remove-device" />}>
                                            <Row gutter={16}>
                                                <Col span={12}><Form.Item label="Product Variant" validateStatus={deviceErrors[`${deviceType}-${index}`]?.productVariant ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.productVariant || ""}><Select value={device.productVariant || undefined} onChange={(value) => updateDevice(deviceType, index, "productVariant", value)} placeholder="Select Product Variant" >{getProductVariants(deviceType).map(variant => <Select.Option key={variant} value={variant}>{variant}</Select.Option>)}</Select></Form.Item></Col>
                                                <Col span={12}><Form.Item label="Device Model" validateStatus={deviceErrors[`${deviceType}-${index}`]?.deviceName ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.deviceName || ""}><Select value={device.deviceName || undefined} onChange={(value) => updateDevice(deviceType, index, "deviceName", value)} placeholder="Select Device Name">{DEVICE_TYPE_INFO[deviceType.toUpperCase().split(' ').join('_')].map(deviceOption => <Select.Option key={deviceOption.name} value={deviceOption.name}>{deviceOption.name}</Select.Option>)}</Select></Form.Item></Col>
                                            </Row>
                                            {device.productVariant == NEW_PRODUCT_VARIANTS.ACTIVE_TEACH && (
                                                <Row gutter={16}>
                                                    <Col span={8}><Form.Item label="Active Teach Version" validateStatus={deviceErrors[`${deviceType}-${index}`]?.activeTeachVersion ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.activeTeachVersion || ""}><Select value={device.activeTeachVersion || undefined} onChange={(value) => updateDevice(deviceType, index, "activeTeachVersion", value)} placeholder="Select Active Teach Version" >{["Old", "New"].map(variant => <Select.Option key={variant} value={variant}>{variant}</Select.Option>)}</Select></Form.Item></Col>
                                                </Row>
                                            )}
                                            {deviceType === 'PENDRIVE' && (
                                                <Row gutter={16}>
                                                    <Col span={12}><Form.Item label="Installation Mode" validateStatus={deviceErrors[`${deviceType}-${index}`]?.installationMode ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.installationMode || ""}><Select value={device.installationMode || undefined} onChange={(value) => updateDevice(deviceType, index, "installationMode", value)} placeholder="Select Installation Mode" >{["Server", "Classroom"].map(variant => <Select.Option key={variant} value={variant}>{variant}</Select.Option>)}</Select></Form.Item></Col>
                                                    <Col span={12}><Form.Item label="Operating System" validateStatus={deviceErrors[`${deviceType}-${index}`]?.operatingSystem ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.operatingSystem || ""}><Select value={device.operatingSystem || undefined} onChange={(value) => updateDevice(deviceType, index, "operatingSystem", value)} placeholder="Select Operating System">{["Windows", "Linux"].map(variant => <Select.Option key={variant} value={variant}>{variant}</Select.Option>)}</Select></Form.Item></Col>
                                                </Row>
                                            )}
                                            {(deviceType === 'TAB' || deviceType === 'SDCARD') && (
                                                <Row align="middle" gutter={16}>
                                                    <Col span={12}><Form.Item label="Orbiter Profile ID" validateStatus={deviceErrors[`${deviceType}-${index}`]?.orbiterProfileId ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.orbiterProfileId || ""}><Select showSearch value={device.orbiterProfileId || undefined} onChange={(value) => {
                                                        const selectedProfile = STATIC_ORBITER_PROFILES.find(profile => profile.id === value);
                                                        if (selectedProfile) {
                                                            updateDevice(deviceType, index, "orbiterProfileId", selectedProfile.id);
                                                            updateDevice(deviceType, index, "orbiterProfileName", selectedProfile.name);
                                                        }
                                                    }} placeholder="Search Orbiter Profile" optionFilterProp="children"
                                                        filterOption={(input, option) => {
                                                            const id = String(option.props.profileid || "").toLowerCase();
                                                            const name = String(option.props.profilename || "").toLowerCase();
                                                            return id.includes(input.toLowerCase()) || name.includes(input.toLowerCase());
                                                        }}
                                                    >
                                                        {STATIC_ORBITER_PROFILES.map(option => <Select.Option key={option.id} value={option.id} profileid={option.id} profilename={option.name}><Tooltip title={option.name}>({option.id}) {option.name}</Tooltip></Select.Option>)}</Select></Form.Item></Col>
                                                    <Col span={12}><Form.Item label="SD Card Size" validateStatus={deviceErrors[`${deviceType}-${index}`]?.sdCardSize ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.sdCardSize || ""}><Select value={device.sdCardSize || undefined} onChange={(value) => updateDevice(deviceType, index, "sdCardSize", value)} placeholder="Select SD Card size">{SD_CARD_SIZES.map(size => <Select.Option key={size} value={size}>{size}</Select.Option>)}</Select></Form.Item></Col>
                                                </Row>
                                            )}
                                            {deviceType === 'PANEL' && (
                                                <Row gutter={16}>
                                                    <Col span={12}><Form.Item label="Brand" validateStatus={deviceErrors[`${deviceType}-${index}`]?.brand ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.brand || ""}><Input value={device.brand || undefined} placeholder="Enter brand" onChange={(e) => updateDevice(deviceType, index, "brand", e.target.value)} /></Form.Item></Col>
                                                </Row>
                                            )}
                                            {deviceType === 'TAB' && (
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <Form.Item label="Is Techbook?">
                                                            <Radio.Group
                                                                value={device.isTechbook}
                                                                onChange={e => updateDevice(deviceType, index, "isTechbook", e.target.value)}
                                                            >
                                                                <Radio value={true}>Yes</Radio>
                                                                <Radio value={false}>No</Radio>
                                                            </Radio.Group>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            )}
                                            <Row gutter={16} align="middle">
                                                <Col span={8}>
                                                    <Form.Item label="Nucleus ID exists">
                                                        <Radio.Group
                                                            value={device.nucleusIdExists}
                                                            onChange={e => updateDevice(deviceType, index, "nucleusIdExists", e.target.value)}
                                                        >
                                                            <Radio value={true}>Yes</Radio>
                                                            <Radio value={false}>No</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={9}><Form.Item label="Nucleus ID" validateStatus={deviceErrors[`${deviceType}-${index}`]?.nucleusId ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.nucleusId || ""}><Input value={device.nucleusId || ""} placeholder="Enter Nucleus ID" onChange={(e) => updateDevice(deviceType, index, "nucleusId", e.target.value)}
                                                    disabled={!device.nucleusIdExists || deviceLoading[`${deviceType}-${index}`]}
                                                    suffix={
                                                        <Button
                                                            type="primary"
                                                            size="small"  // Makes button size consistent
                                                            icon={<SearchOutlined />}
                                                            disabled={!device.nucleusIdExists || deviceLoading[`${deviceType}-${index}`]} // Disable button when searching
                                                            onClick={() => handleSearch(deviceType, index, device.nucleusId)}
                                                        />
                                                    } /></Form.Item>
                                                    {nucleusErrors[`${deviceType}-${index}`] && <div style={{ color: "red" }}>{nucleusErrors[`${deviceType}-${index}`]}</div>}
                                                </Col>
                                                <Col span={10}>
                                                    <Form.Item label="School Name">
                                                        <Input
                                                            value={device.schoolName || ""}
                                                            disabled={device.nucleusIdExists}
                                                            style={device.nucleusIdExists ? { backgroundColor: "#f5f5f5", color: "#888" } : {}}
                                                            onChange={e => {
                                                                if (!device.nucleusIdExists) updateDevice(deviceType, index, "schoolName", e.target.value);
                                                            }}
                                                            placeholder={device.nucleusIdExists ? undefined : "Enter School Name"}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={3}><Form.Item label="Quantity" validateStatus={deviceErrors[`${deviceType}-${index}`]?.quantity ? "error" : ""} help={deviceErrors[`${deviceType}-${index}`]?.quantity}><InputNumber min={1} max={50} value={device.quantity} onChange={(value) => updateDevice(deviceType, index, "quantity", value)} /></Form.Item></Col>
                                            </Row>
                                        </Card>
                                    ))}
                                    <Button className="add-device-btn" onClick={() => addDevice(deviceType)} disabled={devices[deviceType].length >= 3}>Add {deviceType}</Button>
                                </Tabs.TabPane>
                            ))}
                        </Tabs>
                        <Button type="primary" htmlType="submit" className="submit-btn" disabled={isSubmitDisabled}>Submit Order</Button>
                    </Form>
                </Card>
            </div>
            <Modal title="Order Created" open={modalVisible} onOk={() => setModalVisible(false)} onCancel={() => setModalVisible(false)}>
                <p>Your order is created, order ID: <strong>{orpOrderId}</strong></p>
            </Modal>
        </div>
    );
};

export default OrderCreationComponent;